import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CellExportFacade, NotebookCellFacade, NotebookFacade, NotebookSecretFacade } from '@mode/notebooks/contract';
import { NotebookSecretService } from './notebook-secret/notebook-secret.service';
import { NotebookSecretEffects } from './notebook-secret/notebook-secret.effects';
import * as fromNotebookSecret from './notebook-secret/notebook-secret.reducer';
import { CellExportService } from './cell-export/cell-export.service';
import { CellExportEffects } from './cell-export/cell-export.effects';
import * as fromCellExport from './cell-export/cell-export.reducer';
import { NotebookService } from './notebook/notebook.service';
import { NotebookEffects } from './notebook/notebook.effects';
import { NotebookCellService } from './notebook-cell/notebook-cell.service';
import { NotebookStateService } from './notebook-state.service';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromNotebookSecret.notebookSecretFeatureKey, fromNotebookSecret.reducer),
    StoreModule.forFeature(fromCellExport.cellExportFeatureKey, fromCellExport.cellExportReducer),
    EffectsModule.forFeature([NotebookSecretEffects, CellExportEffects, NotebookEffects]),
  ],
  providers: [
    { provide: NotebookSecretFacade, useClass: NotebookSecretService },
    { provide: NotebookFacade, useClass: NotebookService },
    { provide: CellExportFacade, useClass: CellExportService },
    { provide: NotebookCellFacade, useClass: NotebookCellService },
    NotebookStateService,
  ],
})
export class NotebooksDomainModule {}
